import { gql } from '@apollo/client';

import { DepositorFields } from '../escrow/escrowDepositor.fragment';
import { BeneficiaryFields } from '../escrow/escrowBeneficiary.fragment';
import { EscrowInvitationFields } from '../escrow/escrowInvitation.fragment';
import { EscrowAgreementFields } from '../escrow/escrowAgreement.fragment';

import { ContinuityEscrowPolicyFields } from './continuityEscrow.fragment';
import { ContinuityProviderFields } from './continuityProvider.fragment';

export * from './continuityEscrow.query.generated';

export const CONTINUITY_ESCROW = gql`
  ${ContinuityEscrowPolicyFields}
  ${DepositorFields}
  ${BeneficiaryFields}
  ${EscrowInvitationFields}
  ${EscrowAgreementFields}
  ${ContinuityProviderFields}
  query continuityEscrow($continuityEscrowId: ID!) {
    continuityEscrow(continuityEscrowId: $continuityEscrowId) {
      ...ContinuityEscrowBaseFields
      activationNotification
      agreement {
        ...EscrowAgreementFields
        protectionPeriod
      }
      agreementSettingsConfigured
      currentCompanyRole
      beneficiaryConfigured
      beneficiarySharedInformation
      beneficiaryActivityNotification
      beneficiaryDisruptionNotification
      beneficiaryDisruptionNotificationGracePeriod
      depositorActivityNotification
      depositorDisruptionNotification
      depositorDisruptionNotificationGracePeriod
      depositorConfigured
      escrowTermination {
        id
        requesterParty
        policy {
          accept
          reject
        }
      }
      startedBy
      depositor {
        ...DepositorFields
      }
      beneficiary {
        ...BeneficiaryFields
      }
      escrowInvitation {
        ...EscrowInvitationFields
      }
      hostingProviders {
        ...ContinuityProviderFields
      }
      policy {
        ...ContinuityEscrowPolicyFields
      }
      reportsEnabled
      requiredContentTypes
      startedBy
      thirdPartyProviders {
        ...ContinuityProviderFields
      }
    }
  }
`;
